import httpService from "./httpService";

export const crmService = {
  save,
  query,
  getById,
  remove,
  keepSaisie,
  sendSaisie,
  updateSaisie,
  removeSaisie,
  updateDateMaj,
};

function query(filterBy = {}) {
  let queryStr = "?";
  for (const key in filterBy) {
    queryStr += `${key}=${filterBy[key]}&`;
  }
  // console.log("le query gg est : ", queryStr);
  return httpService.get(`crm${queryStr || ""}`);
}

function getById(crmId) {
  //console.log(crmId);
  return httpService.get(`crm/${crmId}`);
}

function remove(crmId) {
  return httpService.delete(`crm/${crmId}`);
}

function save(crm) {
  //console.log(crm);
  if (crm._id) {
    return httpService.put(`crm/${crm._id}`, crm);
  } else {
    return httpService.post(`crm`, crm);
  }
}
function keepSaisie(filterBy = {}) {
  let queryStr = "?";
  for (const key in filterBy) {
    queryStr += `${key}=${filterBy[key]}&`;
  }
  return httpService.get(`saisie${queryStr || ""}`);
}

function sendSaisie(data) {
  return httpService.post("saisie", data);
}

function updateSaisie(data) {
  return httpService.put(`saisie/${data._id}`, data);
}

function removeSaisie(saisieId) {
  return httpService.delete(`saisie/${saisieId}`);
}
function updateDateMaj(crmId) {
  return httpService.put(`crm/${crmId}/date-maj`);
}
